import React from 'react';
import { NavItem, NavLink, Nav } from 'reactstrap';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { ToggleMobileSidebar } from '../../../store/customizer/CustomizerSlice';

const NavSubItem = ({ to, icon, title, items, suffix,  suffixColor, ddType, className }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [isOpen, setIsOpen] = React.useState(false);
  
  const HandletoggleNavbar = () => {
    dispatch(ToggleMobileSidebar());
	  setIsOpen(!isOpen);
  };

  const Handletoggle = () => {
	 setIsOpen(!isOpen);
  };

  return (
    <NavItem className={classNames(`collapsed && getActive ? 'activeParent' : '' ${ddType} admin_list`, className || '')}>
      <NavLink to={to} className="gap-1 cursor-pointer" onClick={Handletoggle}>
        <span className="sidebarIcon d-flex align-items-center">{icon}</span>
        <div className="d-flex flex-grow-1 align-items-center gap-1">
          <span className="me-auto">{title}</span>
          {suffix ? <span className={`badge  ${suffixColor}`}>{suffix}</span> : ''}
          <i className="bi bi-chevron-down" />
        </div>
      </NavLink>
      <Nav vertical className={`firstDD bg-white text-black ${isOpen ? 'showfirstDD' : ''}`}>
        {items.map((item) => (
          <NavItem key={item.title} className={`${location.pathname === item.href ? 'activeLink' : ''}`} onClick={HandletoggleNavbar}>
            <NavLink tag={Link} to={item.href}>
              <span className="sidebarIcon">{item.icon}</span>
              <span className="">
                <span>{item.title}</span>
              </span>
            </NavLink>
          </NavItem>
        ))}
      </Nav>
    </NavItem>
  );
};

NavSubItem.propTypes = {
  title: PropTypes.string,
  to: PropTypes.string,
  icon: PropTypes.node,
  items: PropTypes.array,
  suffix: PropTypes.any,
  // activeBck: PropTypes.string,
  suffixColor: PropTypes.string,
  ddType: PropTypes.string,
};
export default NavSubItem;
